import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "../../../../global/cnr/reducers/reducerHelpers/dispatchProps";
import { getFirstObject } from '../../../../global/common/convert';
import { deleteFromObject, getGroupListData, removeFromObject } from '../../../../global/common/sorting';
import { sendMatchMessage } from "../../../sports/cnr/reducers/SportsDataReducer";
import { calcMatchStatus } from "../../golfCalcs/calcMatchStatus";
import { golfFixHelpers } from "./reducerHelpers/golfFix";
import { golfTournamentHelpers } from "./reducerHelpers/golfTournamentHelpers";

const removeFields_golferTournament = ['_itemKey', 'id', 'handicap', 'checked']

const deleteFields_golferTournament = [
  '_authId',
  '_existingKey',
  '_itemKey',
  'firstName',
  'handicapIndex',
  'handicapSourceType',
  'lastName',
  'name',
  'phoneNumber',
  'shortName',
  'teebox',
  'id',
  'key',
  '_authData',
  '_dateProps',
  '_updateDate',
  'auth_uid',
]

const _tournamentAllows = Object.freeze({
  allowAutoScoring: 'allowAutoScoring',
  allowNonAuthScoring: 'allowNonAuthScoring',
  allowTempAccess: 'allowTempAccess',
  matchCubeType: 'matchCubeType',
  showGolferHoleScoring: 'showGolferHoleScoring',
  showGolferTeamHoleScoring: 'showGolferTeamHoleScoring',
  tournamentIsActive: 'tournamentIsActive',
  tournamentIsLocked: 'tournamentIsLocked',
})

export const fields_golferTournament = ['courseHandicaps', 'courseTeeboxes', 'tournamentHandicapIndex', 'teamNumber', 'noTrueCourseHandicap']

export const rts = {
  handleAmmend_tournamentInfo: 'handleAmmend_tournamentInfo',
  handleAmmend_matchStartOrder: 'handleAmmend_matchStartOrder',
  handleAmmend_roundLineup: 'handleAmmend_roundLineup',
  handleAmmend_tempAppUserAccess: 'handleAmmend_tempAppUserAccess',
  handleArchive_tournament: 'handleArchive_tournament',
  handleChange_golferTeam: 'handleChange_golferTeam',
  handleCheck_eventGolfer: 'handleCheck_eventGolfer',
  handleFix_golfersTournament: 'handleFix_golfersTournament',
  handleFix_golfersTournamentHandicaps: 'handleFix_golfersTournamentHandicaps',
  handleFix_golfTournament: 'handleFix_golfTournament',
  handleFix_golfTournamentFromMatches: 'handleFix_golfTournamentFromMatches',
  handleGetSelectedTeamGolfers: 'handleGetSelectedTeamGolfers',
  handleLineup_init: 'handleLineup_init',
  handleLineup_select: 'handleLineup_select',
  handleReset_matches: 'handleReset_matches',
  handleResponse_lineupUpdated: 'handleResponse_lineupUpdated',
  handleSet_golfTournament: 'handleSet_golfTournament',
  handleSet_initGolfTournament: 'handleSet_initGolfTournament',
  handleSet_tournamentInfo: 'handleSet_tournamentInfo',
  handleShow_createArchive: 'handleShow_createArchive',
  handleShow_edit: 'handleShow_edit',
  handleShow_expandedMatches: 'handleShow_expandedMatches',
  handleShow_inlineCubes: 'handleShow_inlineCubes',
  handleShow_sortByTeam: 'handleShow_sortByTeam',
  handleShow_tournamentChart: 'handleShow_tournamentChart',
  handleShow_wizard: 'handleShow_wizard',
  handleStart_autoScoring: 'handleStart_autoScoring',
  handleStop_autoScoring: 'handleStop_autoScoring',
  handleUpdate_golfCourse: 'handleUpdate_golfCourse',
  handleToggle_roundRandomScoring: 'handleToggle_roundRandomScoring',
  ...grts,
}

export const golfTournamentReducer = (state, action) => {

  const { golfEvent_state, golfers: golfers_tournament, matches: matches_state, autoScoringOn } = state
  const { golfCourses } = golfEvent_state ?? {}

  const { type, dispatch } = action

  switch (type) {

    case rts.handleAmmend_tournamentInfo:
      const { tournamentInfo } = action
      const { details, matches } = tournamentInfo ?? {}
      const { golfTournament, golfCourse: _golfCourse, _details } = doSomething(tournamentInfo, golfCourses)

      const tss = golfTournamentHelpers.ammendTournament_matchesStatus({
        details,
        golfCourse: _golfCourse,
        golfEvent_state,
        golfTournament,
        matches,
      })

      const { golferRecords, golferRecordsSorted } = golfTournamentHelpers.getGolferResults({ matches, golfers: golfers_tournament, golfCourse: _golfCourse, teams: {} })
      // console.log('tss', tss)
      // console.log('golferRecords', golferRecords)
      // console.log('_golfCourse', _golfCourse)
      return {
        ...state,
        _details,
        details,
        golfCourse: _golfCourse,
        golfTournament,
        tournamentStatus: tss.ts,
        roundsStatus: tss.roundsStatus,
        matches_rounds: tss.matches_rounds,
        matches_golfTournament: tss.matches_golfTournament,
        matches: matches,
        // golferMatches: action.golferMatches,
        golferRecords,
        golferRecordsSorted
      }

    case rts.handleSet_initGolfTournament:
      // this will update with any of the core tournament changes
      // console.log('matches', state.matches)
      const a = golfTournamentHelpers.initGolfTournamentData(
        {
          details: state.details,
          golfCourse: state.golfCourse,
          golfTournament: state.golfTournament,
          matches: state.matches,
          tournamentGolfCourses: state.tournamentGolfCourses,
          golfEvent_state
        }
      )
      const tournamentGolfCourses = golfTournamentHelpers.getTournamentCourses(
        {
          golfEvent_state,
          details: state.details,
        }
      )
      const p = {
        ...state,
        ...a,
        tournamentGolfCourses
      }
      return { ...p }

    case rts.handleAmmend_tempAppUserAccess:
      return { ...state, tempAppUserAccess: action.tempAccess };

    case rts.handleAmmend_matchStartOrder:
      return { ...state, showCompletedMatchesLast: !state.showCompletedMatchesLast };

    case rts.handleShow_expandedMatches:
      return { ...state, showExpandedMatches: !state.showExpandedMatches };

    case rts.handleShow_inlineCubes:
      return { ...state, showInlineCubes: !state.showInlineCubes };

    case rts.handleShow_sortByTeam:
      return { ...state, showSortByTeam: !state.showSortByTeam };

    case rts.handleShow_wizard:
      return { ...state, showWizard: !state.showWizard, wizardOpts: action.wizardOpts };

    case rts.handleCheck_eventGolfer:
      const { item } = action
      const cg = item._itemKey === state.checkedGolfer ? null : item._itemKey
      return { ...state, checkedGolfer: cg }


    case rts.handleSet_tournamentInfo:
      return { ...state, info: action.info }

    case rts.handleResponse_lineupUpdated:
      if (state.cb_action) { state.cb_action() }
      return { ...state, updating: false }

    case rts.handleSet_golfTournament:
      return {
        golfTournaments: action.gt,
        ...state,
      }

    case rts.handleUpdate_golfCourse:
      const { item: gc } = getFirstObject(action.golfCourse)
      return { ...state, golfCourse: gc }

    case rts.handleLineup_init:
      const _selectedKeys = []
      const { lineupInfo } = action
      const { teamRoundLineup, golfers_lineup, golfers_team } = lineupInfo ? lineupInfo : {}
      if (teamRoundLineup) {
        teamRoundLineup.forEach(g => {
          _selectedKeys.push(g.golferKey)
        })
        const _golfers = golfTournamentHelpers.getSeletedTeamGolfers(_selectedKeys, golfers_lineup, golfers_team)
        const _sorted = _golfers ? getGroupListData(_golfers, null, 2, 'group') : {}
        return { ...state, lineupInfo: { roundLineup: teamRoundLineup, selectedKeys: _selectedKeys, golfers: _golfers, sorted: _sorted }, selectedLineupItems: _selectedKeys }
      }
      return { ...state, lineupInfo: {} }

    case rts.handleLineup_select:
      const _lineupInfo = { ...state.lineupInfo }
      const { selectedGolferKeys } = action
      const _roundLineup = _.filter(golfers_tournament, (golfer, key) => _.includes(selectedGolferKeys, key));
      _lineupInfo.selectedKeys = selectedGolferKeys
      _lineupInfo.roundLineup = _roundLineup;
      return { ...state, lineupInfo: _lineupInfo }

    case rts.handleAmmend_roundLineup:
      const _lineupInfo2 = { ...state.lineupInfo }
      _lineupInfo2.roundLineup = action.round_lineup
      return { ...state, lineupInfo: _lineupInfo2 }




    case rts.handleReset_matches:
      const _matches = _.cloneDeep(state?.matches)
      const _roundMatches = _.cloneDeep(_matches[action.roundKey])
      _.forEach(_roundMatches, (m) => {
        delete m.holeWinners
      })
      _matches[action.roundKey] = _roundMatches; // 👈 reassign back
      return { ...state, matches: _matches }


    case rts.handleChange_golferTeam:
      const { tournamentGolfers } = state
      const { player, teamIndex, rowIndex } = action
      const { key: playerKey } = player ? player : {}
      const tgp = tournamentGolfers[playerKey]
      tgp.teamNumber = teamIndex
      return { ...state, tournamentGolfers, rowIndex }

    case rts.handleFix_golfTournament:
      golfFixHelpers.fixTournament(state)
      return state

    case rts.handleFix_golfTournamentFromMatches:
      golfFixHelpers.fixFromMatches(state)
      return state

    case rts.handleFix_golfersTournamentHandicaps:
      golfFixHelpers.fixGolferHandicaps(state)
      return state

    case rts.handleFix_golfersTournament:
      golfFixHelpers.fixGolfers_tournament(state)
      return state

    case rts.handleShow_edit:
      action.e && action.e.stopPropagation()
      return { ...state, showEdit: !state.showEdit }

    case rts.handleShow_createArchive:
      action.e && action.e.stopPropagation()
      return { ...state, showCreateArchive: !state.showCreateArchive }

    case rts.handleArchive_tournament:
      golfTournamentHelpers.archiveTournment(state)
      return { ...state, showCreateArchive: false }


    case rts.handleShow_tournamentChart:
      const _showRoundCharts = state.showRoundCharts ? state.showRoundCharts : {}
      _showRoundCharts[action.roundKey] = !_showRoundCharts[action.roundKey]
      return { ...state, showRoundCharts: _showRoundCharts }

    case rts.handleStart_autoScoring:
      let roundTimeline = null
      return {
        ...state,
        autoScoringOn: true,
        autoScoringRoundKey: action.roundKey,
        roundTimeline
      }

    case rts.handleStop_autoScoring:
      return {
        ...state,
        autoScoringOn: false,
        autoScoringRoundKey: null,
      }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse: s
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return state
  }
}

export const golfTournamentHandlers = (dispatch) => {
  return {
    handleAmmend_tournamentInfo: (tournamentInfo) => { dispatch({ type: rts.handleAmmend_tournamentInfo, dispatch, tournamentInfo }) },
    handleAmmend_matchStartOrder: () => { dispatch({ type: rts.handleAmmend_matchStartOrder, dispatch }) },
    handleAmmend_roundLineup: (round_lineup) => { dispatch({ type: rts.handleAmmend_roundLineup, dispatch, round_lineup }) },
    handleAmmend_tempAppUserAccess: (tempAccess) => { dispatch({ type: rts.handleAmmend_tempAppUserAccess, tempAccess }) },
    handleArchive_tournament: () => { dispatch({ type: rts.handleArchive_tournament }) },
    handleChange_golferTeam: (player, teamIndex, rowIndex) => { dispatch({ type: rts.handleChange_golferTeam, player, teamIndex, rowIndex }) },
    handleCheck_eventGolfer: (e, item, itemChecked) => { dispatch({ type: rts.handleCheck_eventGolfer, dispatch, e, item, itemChecked }) },
    handleFix_golfersTournament: () => { dispatch({ type: rts.handleFix_golfersTournament, dispatch }) },
    handleFix_golfersTournamentHandicaps: () => { dispatch({ type: rts.handleFix_golfersTournamentHandicaps, dispatch }) },
    handleFix_golfTournament: () => { dispatch({ type: rts.handleFix_golfTournament, dispatch }) },
    handleLineup_init: (lineupInfo) => { dispatch({ type: rts.handleLineup_init, dispatch, lineupInfo }) },
    handleLineup_select: (selectedGolferKeys) => { dispatch({ type: rts.handleLineup_select, dispatch, selectedGolferKeys }) },
    handleReset_matches: (roundKey) => { dispatch({ type: rts.handleReset_matches, dispatch, roundKey }) },
    handleResponse_lineupUpdated: () => { dispatch({ type: rts.handleResponse_lineupUpdated, dispatch }) },
    handleSet_golfTournament: (gt) => { dispatch({ type: rts.handleSet_golfTournament, dispatch, gt }) },
    handleSet_initGolfTournament: () => { dispatch({ type: rts.handleSet_initGolfTournament }) },
    handleSet_tournamentInfo: (info) => { dispatch({ type: rts.handleSet_tournamentInfo, info, dispatch }) },
    handleShow_createArchive: (e) => { dispatch({ type: rts.handleShow_createArchive, dispatch, e }) },
    handleShow_edit: (e) => { dispatch({ type: rts.handleShow_edit, dispatch, e }) },
    handleShow_expandedMatches: () => { dispatch({ type: rts.handleShow_expandedMatches, dispatch }) },
    handleShow_inlineCubes: () => { dispatch({ type: rts.handleShow_inlineCubes, dispatch }) },
    handleShow_sortByTeam: () => { dispatch({ type: rts.handleShow_sortByTeam, dispatch }) },
    handleShow_tournamentChart: (roundKey) => { dispatch({ type: rts.handleShow_tournamentChart, roundKey }) },
    handleShow_wizard: (wizardOpts) => { dispatch({ type: rts.handleShow_wizard, dispatch, wizardOpts }) },
    handleStart_autoScoring: (roundKey) => { dispatch({ type: rts.handleStart_autoScoring, roundKey }) },
    handleStop_autoScoring: () => { dispatch({ type: rts.handleStop_autoScoring }) },
    handleUpdate_golfCourse: (golfCourse) => { dispatch({ type: rts.handleUpdate_golfCourse, golfCourse, dispatch }) },
    ...responseHandlers(dispatch)
  }
}

export const golfTournamentInitialState = (init_state) => {
  return {
    ...init_state,
    _propAllows: _tournamentAllows,
  }
};

const doSomething = (tournamentInfo, golfCourses) => {
  const { main: gt, details, _details } = tournamentInfo ?? {}
  const { golfers } = details ?? {}

  let golfCourse;

  if (gt && gt.golfCourse) {
    if (golfCourses && golfCourses[gt.golfCourse]) {
      golfCourse = golfCourses[gt.golfCourse]
      // } else {
      // database_fns.get_data_any({ pathViews, collectionName: 'golfCourses', callback: handleUpdate_golfCourse, opts: { docKey: t.golfCourse, clientPath: true } })
    }
  }

  let playersPerTeam = 2

  if (golfers) {
    const totalGolfers = Object.keys(golfers).length
    playersPerTeam = totalGolfers / 2
    gt.playersPerTeam = playersPerTeam

    Object.keys(golfers).forEach(key => {
      if (golfers[key].teamNumber) {
        golfers[key].teamNumber = parseInt(golfers[key].teamNumber)
        golfers[key].key = key
      }
    })
  }

  return { golfTournament: gt, golfCourse, details, _details }

}